export default __webpack_public_path__ + "static/media/bkg--design-1.f66fe143.jpg";